import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    signatures: {},
    signature: {},
    signatures_expired: {}
  },
  getters: {
    
  },
  actions: {
    async get_signatures({ commit }) {
      try {
        //api.get("/v1/subscriber-plans")
          api.get("/v1/signatures")
          .then((res) => {
            commit("GET_SIGNATURES", res.data);
          })
          .catch((error) => {
            commit("ERROR_SIGNATURE", "Erro ao carregaras assinaturas");
          })
          .finally(() => (
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_SIGNATURE", e);
      }
    },

    async get_signatures_expired({ dispatch, commit }) {
      try {
          api.get("/v1/signatures-expired")
          .then((res) => {
            commit("GET_SIGNATURES_EXPIRED", res.data);
            if(res.data.erro){
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });
            
              //if (window.innerWidth < 480) {
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}
            }
          })
          .catch((error) => {
            commit("ERROR_SIGNATURE_EXPIRED", "Erro ao carregaras assinaturas");
          })
          .finally(() => (
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_SIGNATURE_EXPIRED", e);
      }
    },
    
    async create_signature({ commit }, payload = []){
      try {
        const res = await api.post("/v1/create-signature", payload);
        commit("GET_ADD_SIGNATURES", res.data);
        return res; // Retorna a resposta da criação da assinatura
      } catch (error) {
        commit("ERROR_ADD_SIGNATURE", "Não foi possível criar a assinatura");
        throw error; // Lança o erro para que o catch no componente seja ativado
      } finally {
        console.log('Login request ended');
      }
    }, 
    
    async disable_signature({ commit }, payload = []){
      try {
        const res = await api.post("/v1/disable-signature", payload);
        commit("GET_UPT_SIGNATURES", res.data);
        return res; // Retorna a resposta da criação da assinatura
      } catch (error) {
        commit("ERROR_UPT_SIGNATURE", "Não foi possível atualizar a assinatura");
        throw error; // Lança o erro para que o catch no componente seja ativado
      } finally {
        console.log('Login request ended');
      }
    },  
    
    async cancel_due_date({ dispatch, commit }, payload = []){
      try {
        api.post("/v1/cancel-due-date", payload)
          .then((res) => {
            commit("GET_CANCEL_DATES", res.data);
            //dispatch("alert/set_alert", {alert_message: "Assinatura será cancelada na data de vencimento!", type_message: 'alert-warning'}, { root: true });
          
            toast.warning(res?.data?.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });

          })
          .catch((error) => {
            commit("ERROR_CANCEL_DATE", "Nao foi possivel criar a asssinatura");
          })
          .finally(() => (
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CANCEL_DATE", "Nao foi possivel criar a asssinatura");
      }
    },   

  },
  mutations: {
    GET_SIGNATURES(state, data) {
      state.signatures = data
    },
    ERROR_SIGNATURE(state, data) {
      console.log(data)
    },

    GET_SIGNATURES_EXPIRED(state, data) {
      state.signatures_expired = data
    },
    ERROR_SIGNATURE_EXPIRED(state, data) {
      console.log(data)
    },

    GET_ADD_SIGNATURES(state, data) {
      state.signature = data
    },
    ERROR_ADD_SIGNATURE(state, data) {
      console.log(data)
    },

    GET_UPT_SIGNATURES(state, data) {
      state.signature = data
    },
    ERROR_UPT_SIGNATURE(state, data) {
      console.log(data)
    },

    GET_CANCEL_DATES(state, data) {
      state.signature = data
    },
    ERROR_CANCEL_DATE(state, data) {
      console.log(data)
    },
  }
}